import { Injectable } from '@angular/core';
import { Headers, Http, Response, RequestOptions, ResponseContentType } from '@angular/http';

@Injectable()
export class SignatoryService {
  constructor(private http: Http) {
  }
  SaveSignatory(data: any) {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    return this.http.post('/api/Subscription/SaveSignatory', data, options)
      .map((res: Response) => res.json());
  }

  GetSignatoryByHotelID(hotelID: number) {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    return this.http.get('/api/Subscription/GetSignatoryByHotelID?hotelID=' + hotelID, options)
      .map((res: Response) => res.json());
  }


}



// WEBPACK FOOTER //
// ./src/app/Services/Signatory.service.ts